import { css } from 'styled-components'

import OmnesLight_EOT from '@assets/fonts/omnes_light-webfont.eot'
import OmnesLight_WOFF from '@assets/fonts/omnes_light-webfont.woff'
import OmnesLight_TTF from '@assets/fonts/omnes_light-webfont.ttf'
import OmnesLight_SVG from '@assets/fonts/omnes_light-webfont.svg'

import OmnesMedium_EOT from '@assets/fonts/omnes_medium-webfont.eot'
import OmnesMedium_WOFF from '@assets/fonts/omnes_medium-webfont.woff'
import OmnesMedium_TTF from '@assets/fonts/omnes_medium-webfont.ttf'
import OmnesMedium_SVG from '@assets/fonts/omnes_medium-webfont.svg'

const fontConfig = () => css`
  @font-face {
    font-family: 'Omnes';
    src: url(${OmnesLight_EOT});
    src: url(${OmnesLight_EOT}#iefix) format('embedded-opentype'), url(${OmnesLight_WOFF}) format('woff'), url(${OmnesLight_TTF}) format('truetype'),
      url(${OmnesLight_SVG}#webfont) format('svg');

    font-weight: lighter;
  }
  @font-face {
    font-family: 'Omnes';
    src: url(${OmnesMedium_EOT});
    src: url(${OmnesMedium_EOT}#iefix) format('embedded-opentype'), url(${OmnesMedium_WOFF}) format('woff'),
      url(${OmnesMedium_TTF}) format('truetype'), url(${OmnesMedium_SVG}#webfont) format('svg');

    font-weight: bold;
  }
`
export { fontConfig }
